import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdBannerTemplatesUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/banner_templates",
];
